//@flow
import type { AppState } from '../reducers'
import type { State } from './reducer'
import { get } from 'lodash/fp'

export const getEntryComponent = (state: AppState): State => get('entryComponent')(state)
